export interface NestedBlobMetaData {
  ProjectId: string;
  CreatedById: string;
  Module: string;
  FileName: string;
  DisplayName: string;
}
export interface BlobMetaData {
  Name: string;
  ContentType: string;
  Content?: string;
  Uri: string;
  BlobMetadata: NestedBlobMetaData;
}
export interface FileModel {
  id: string;
  name?: string;
  createdDate: Date;
  expiryDate: Date;
  projectName: string;
  contentType?: string;
  createdBy: string;
  blobMetadata: BlobMetaData;
}

export interface FileUploadParameters {
  file: Blob | File;
  metadata: {
    SourceOrigin: FileUploadSource;
    DataType: FileUploadSource;
    [key: string]: any;
  };
}

export type UnionBuffer = string | ArrayBuffer | Blob | Uint8Array;

export enum FileUploadSource {
  POWERPOINT_EXPORT = 'FrontendPowerpointExport',
  ElsieAiExport = 'ElsieAiExport',
}
